<template lang="pug">
div(v-if="usuarioLogado")
  el-row.labelDiv(:gutter="30")
    el-col.inputDiv(:span="8")
      validation-provider(rules="required", v-slot="{ errors }", :name="nomeAba + '/Cpf/Cnpj'")
        app-label(label="CPF/CNPJ:", :required="true")
        el-input.input(
          :disabled="true"
          name="cpfCnpj"
          :value="cadastrante.pessoa.cpfCnpj",
          v-mask="['###.###.###-##', '##.###.###/####-##']",
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}

    el-col.inputDiv(:span="16")
      validation-provider(rules="required", v-slot="{ errors }", :name="nomeAba + '/Nome/Razão social'")
        app-label(label="Nome/Razão social:", :required="true")
        el-input.input(
          name="nomeRazaoSocial"
          maxlength="300"
          v-model="cadastrante.pessoa.nomeRazaoSocial",
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}
  el-row.labelDiv(:gutter="30")
    app-endereco(v-if="!isMaranhao" :endereco="cadastrante.pessoa.endereco", nomeAba="Cadastrante")
</template>

<script>
import AppEndereco from '@/components/AppEndereco'
import AppLabel from '@/components/AppLabel'
import { mapActions, mapGetters } from 'vuex'

export default {

  props: {
    cadastrante: {
      type: Object,
      required: true
    },
    isProcessoFisico: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  components: {
    AppEndereco,
    AppLabel
  },

  data () {
    return {
      nomeAba: 'Cadastrante',
      isMaranhao: process.env.ESTADO === 'ma',
      funcionarioIterma: this.$route.name !== 'liberacao-clausula/cadastrante'
    }
  },

  async created () {
    if (this.isMaranhao) {
      if (!this?.cadastrante?.pessoa) {
        this.cadastrante.pessoa = await this.findPessoa(this.usuarioLogado.pessoa.pessoaFisica ? this.usuarioLogado.pessoa.pessoaFisica.cpf
          : this.usuarioLogado.pessoa.pessoaJuridica.cnpj)
        this.cadastrante.pessoa.telefones = this.cadastrante.pessoa.telefones.map(item => item.numero)
      }

      this.cadastrante.pessoa['funcionarioIterma'] = this.funcionarioIterma
    } else {
      this.cadastrante.pessoa = await this.findPessoa(this.usuarioLogado.pessoa.pessoaFisica ? this.usuarioLogado.pessoa.pessoaFisica.cpf
        : this.usuarioLogado.pessoa.pessoaJuridica.cnpj)
      this.cadastrante.pessoa.telefones = this.cadastrante.pessoa.telefones.map(item => item.numero)
    }
  },

  methods: {
    ...mapActions({
      findPessoa: 'pessoa/findByCpfOrCnpj'
    })
  },

  computed: {
    ...mapGetters({
      usuarioLogado: 'auth/usuarioLogado'
    }),

    cpfCnpj: {
      get () {
        return this.cadastrante.pessoa.cpfCnpj
      },
      set (value) {
        this.cadastrante.pessoa.cpfCnpj = value

        if (this.cadastrante.pessoa.tipo === 'PF') {
          this.cadastrante.pessoa.pessoaFisica.cpf = value
        } else {
          this.cadastrante.pessoa.pessoaJuridica.cnpj = value
        }
      }
    },

    nomeRazaoSocial: {
      get () {
        return this.cadastrante.pessoa.nomeRazaoSocial
      },
      set (value) {
        this.cadastrante.pessoa.nomeRazaoSocial = value

        if (this.cadastrante.pessoa.tipo === 'PF') {
          this.cadastrante.pessoa.pessoaFisica.nome = value
        } else {
          this.cadastrante.pessoa.pessoaJuridica.razaoSocial = value
        }
      }
    }
  },

  watch: {
    funcionarioIterma (val) {
      if (this.isMaranhao) {
        this.cadastrante.pessoa['funcionarioIterma'] = val
      }
    },

    'cadastrante.pessoa.funcionarioIterma' (val) {
      if (this.isMaranhao) {
        this.funcionarioIterma = val
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dados-cadastrante {
    display: flex;
    flex-direction: column;
    gap: 10px;
    height: 50px;
    padding-top: 10px;
  }
@media (max-width: 780px) {
  .labelDiv {
    display: flex;
    flex-direction: column;
  }
  .inputDiv {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/central/components/cadastro/CadastranteSicarf.vue